import React from 'react';
import { newsItems } from '../data/newsData';

const NewsLoggedIn: React.FC = () => {

  return (
    <div style={{ color: '#1f2937' }}>
      <h2 style={{ 
        fontSize: '42px', 
        fontWeight: 'bold', 
        margin: '0 0 20px 0',
        color: '#667eea'
      }}>
        📰 Новости и обновления
      </h2>
      <p style={{ 
        fontSize: '18px', 
        color: '#6b7280',
        margin: '0 0 50px 0'
      }}>
        Следите за последними обновлениями и новыми функциями AvatarMe
      </p>

      {/* Список новостей */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {newsItems.map((news, idx) => (
          <article
            key={idx}
            style={{
              background: 'white',
              padding: '25px 30px',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ 
              fontSize: '13px', 
              color: '#9ca3af', 
              marginBottom: '10px',
              fontWeight: '500'
            }}>
              {news.date}
            </div>
            <h3 style={{ 
              fontSize: '22px', 
              margin: '0 0 12px 0', 
              fontWeight: 'bold',
              lineHeight: '1.3',
              color: '#1f2937'
            }}>
              {news.title}
            </h3>
            <p style={{ 
              fontSize: '15px', 
              margin: '0 0 12px 0', 
              color: '#6b7280', 
              lineHeight: '1.6' 
            }}>
              {news.content}
            </p>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {news.tags.map((tag, tagIdx) => (
                <span
                  key={tagIdx}
                  style={{
                    padding: '4px 12px',
                    background: '#f3f4f6',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#6b7280',
                    border: '1px solid #e5e7eb'
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>

      {/* CTA */}
      <div style={{
        marginTop: '60px',
        padding: '40px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: '12px',
        textAlign: 'center',
        color: 'white'
      }}>
        <h3 style={{ fontSize: '28px', margin: '0 0 12px 0', fontWeight: 'bold' }}>
          Хотите быть в курсе?
        </h3>
        <p style={{ fontSize: '16px', margin: '0 0 20px 0', opacity: 0.95 }}>
          Подпишитесь на наш Telegram-канал, чтобы первыми узнавать о новых функциях
        </p>
        <a
          href="https://t.me/FedorRubtsov"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '14px 35px',
            background: 'white',
            border: 'none',
            borderRadius: '8px',
            color: '#667eea',
            fontSize: '16px',
            fontWeight: 'bold',
            textDecoration: 'none',
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            transition: 'all 0.3s'
          }}
        >
          Подписаться на Telegram
        </a>
      </div>
    </div>
  );
};

export default NewsLoggedIn;
